import { Button, type ButtonProps, Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as Icons from "./Icons";
import { InternalButtonLink } from "./InternalButtonLink";
import { BodyTextS, HeadingS } from "./Typography";

export const StyledInternalButtonLink = styled(InternalButtonLink, {
    shouldForwardProp: (prop) => prop !== "isDesktop",
})<{ isDesktop: boolean }>(({ theme, isDesktop }) =>
    theme.unstable_sx({
        alignSelf: "center",
        width: isDesktop ? undefined : "100%",
        mt: isDesktop ? 0 : 5,
        p: isDesktop ? 3 : 0,
        fontSize: "2rem",
    }),
);

export const MenuButton = styled(({ isActive, ...rest }: { isActive: boolean } & ButtonProps) => (
    <Button variant={"clear" as any} {...rest} />
))<{ isActive: boolean }>(({ theme, isActive }) =>
    theme.unstable_sx({
        display: "block",
        width: "100%",
        p: 0,
        pb: 4,
        borderBottomWidth: "2px",
        borderBottomStyle: "solid",
        borderBottomColor: isActive ? theme.palette.primary.main : theme.palette.common.white,
        borderRadius: 0,
        color: isActive ? theme.palette.primary.main : theme.palette.grey[800],
        textAlign: "unset",
        fontWeight: "unset",
        fontFamily: '"NNNittiGroteskTextRegular", sans-serif',
        "&:focus": {
            outlineStyle: "none",
            borderBottomColor: "primary.main",
            color: "primary.main",
        },
        "&:hover": {
            backgroundColor: "unset",
        },
        "&.Mui-disabled": {
            color: theme.palette.grey[800],
            pointerEvents: "none",
        },
    }),
);

export const ContractListHeading = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        mb: 2,
    }),
);

export const ContractListThirdLine = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
        fontFamily: '"NNNittiGroteskTextBold", sans-serif',
        fontWeight: 600,
        color: "#6D6D6D",
    }),
);

export const PigIcon = styled(Icons.Pig)(({ theme }) =>
    theme.unstable_sx({
        width: "2.4rem",
        height: "2.4rem",
        mr: 4,
    }),
);

export const InsuranceIcon = styled(Icons.Insurance)(({ theme }) =>
    theme.unstable_sx({
        width: "2.4rem",
        height: "2.4rem",
        mr: 4,
    }),
);

export const CaretRightIcon = styled(Icons.CaretRight)(({ theme }) =>
    theme.unstable_sx({
        width: "0.8rem",
        height: "1.3rem",
        ml: 4,
    }),
);

export const InlineLoadingSavingsSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        display: "inline-block",
        width: 100,
        ml: 2,
    }),
);
